import { snackbarService } from '../services/snackbarService';
import { toastSuppressionService } from '../services/toastSuppressionService';

const toastMiddleware = () => (next) => (action) => {
  console.log('Toast Middleware: Processing action', action.type, action);

  // Check for rejected actions - error toasts always show
  if (action.type.endsWith('/rejected')) {
    const errorMessage = 'An unexpected error occurred!';
    console.error('Toast Middleware: Rejected action detected. Message:', errorMessage);
    snackbarService.enqueueSnackbar(errorMessage, { variant: 'error' });
  }
  // Check for fulfilled actions with the showSuccessToast flag
  else if (action.type.endsWith('/fulfilled') && action.meta.arg?.showSuccessToast) {
    if(action.type === "quota-management/quota-adding/create/fulfilled" && action.payload.success === false) {
      return next(action);
    }
    if(action.type === "quota-management/quota-adding/create-override/fulfilled" && action.payload.success === false) {
      return next(action);
    }
    const message = action.payload.success ? 'Data Updated' : 'Update Failed';
    const variant = action.payload.success ? 'success' : 'error';

    // Check suppression for non-error toasts (errors always show)
    if (toastSuppressionService.shouldShowToast({ type: variant, message })) {
      console.log('Toast Middleware: Fulfilled action with success toast detected. Message:', message);
      snackbarService.enqueueSnackbar(message, { variant });
    }
  }

  return next(action);
};

export default toastMiddleware;
